import { GET_ALL_TECHNICIAS,FILTERS_TECHNICIAN } from "../graphql/query/technician/query"; 
import { PASSWORD_RESET_TECHNICIANS } from "../graphql/mutations/technicians/mutations";
import { apiRequests } from "../services/api";
import { MONTH_TECHNICIAN } from "../graphql/query/user/query";

// QUERY
export const getAllTechnicians = async () => {
    try {
        const response = await apiRequests(GET_ALL_TECHNICIAS);
        if(response.data.getAllTechnicians_.status === 3){
            console.error('Fallas en el servidor backend' , response.data.getAllTechnicians_.message);
        }
        if(response.data.getAllTechnicians_.status === 1){
            //console.log(response.data.getAllTechnicians_.message)
            return response.data.getAllTechnicians_;
        }
        if(response.data.getAllTechnicians_.status === 2){
            //console.log(response.data.getAllTechnicians_.message)
            return response.data.getAllTechnicians_.technicians;
        }
        //return response.data.getAllTechnicians;
    }catch(error){
        console.error('Fallas en el servidor fronted: ', error);
        return [];
    }
}

// MUTATIONS
export const passwordReset = async (technicianId,new_password) => {
    try {
        const variables = {
            id_technician:technicianId,
            new_password:new_password
        }
        const response = await apiRequests(PASSWORD_RESET_TECHNICIANS,variables)
        //console.log('respon ', response);
        if(response.data.resetPasswordTechnician?.result){
            return response.data.resetPasswordTechnician;
        }
        if (response.data.resetPasswordTechnician.result == false) {
            return response.data.resetPasswordTechnician;
        } else {
            //console.log('Fallas en el servidor backend.');
            return [];
        }

    }catch(error){
        console.error('Fallas en el servidor fronted: ',error);
        return [];
    }
};


export const filtersTechnician = async (filters = {}) => {
    try {
        const variables = {
            requestFilterTechnician: filters
        }

        const response = await apiRequests(FILTERS_TECHNICIAN,variables);
        if(response.data.filtersTechnician.status){
            //console.log(response.data.filtersTechnician.technicians);
            return response.data.filtersTechnician;
        }else{
            return response.data.filtersTechnician;
        }
    } catch ($e) {
        console.error('resp: ' , $e);
    }
};

export const monthTechnician = async() => {
    try {
        const response = await apiRequests(MONTH_TECHNICIAN);
        if (response.data.dashboardTechnicianMonth) {
            return {
                message:response.data.dashboardTechnicianMonth.message,
                content:response.data.dashboardTechnicianMonth.content,
                status:1
            };
        }
    } catch (err) {
        console.error('Se presento las siguientes fallas: ' , err);
        return [];
    }
};